import React from "react";
import ContactInformationView from "./view";

const ContactInformationPage = () => {
  return <ContactInformationView />;
};

export default ContactInformationPage;